
import { useContext } from 'react';
import BackgroundCardPropsType from '../../types/BackgroundCardPropsType';
import { LangContext, PageContext } from '../../App';

const BackgroundCard = ({ 
    background,
    title,
    type = "image",
    path,
 } : BackgroundCardPropsType) => {
    const {lang} = useContext(LangContext)

    const pageContext = useContext(PageContext);

  return (
    <div className="background-card" >
        {type === "image" ?
        <div className="image-container">
            <img src={background.src} alt={background.alt} /> 
        </div> :
        <div className="image-container">
            <video 
                // ref={videoRef} 
                src={background.src} 
                aria-disabled
                aria-hidden="true"
                aria-label="Meaningless video"
                tabIndex={-1}
                autoPlay 
                loop 
                playsInline
                preload='true'
                controls={false}
                muted
            />
        </div>
        }
        <div className="card-body">
            <button
                // to={path}
                className='card-title'
                title={`${!lang ? "see" : "أقرأ أكثر عن"} ${title}`}
                aria-label={`see ${title}`}
                onClick={() => path ? pageContext.handleChangePage(path) : null}
            >
                {title}
            </button>
        </div>
    </div>
  )
}

export default BackgroundCard